// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__6bSTl","table__table-cell":"Table_table__table-cell__loNmx","table__wrapper-list":"Table_table__wrapper-list__2EuM7"};